import React from 'react';

import SynonymListInput from '../../UserResponseSynonymTable/SynonymList/SynonymListInput';
import SynonymWord from '../../UserResponseSynonymTable/SynonymWord';

import { KEY_CODES } from '../../../constants/MogamboConstants';

import { GOOGLE_ANALYTICS } from '../../../const';
import {
  sendGoogleAnalyticsEvents,
  createAlert,
} from '../../../actions/_utils';

export default class MandatoryWordsModal extends React.Component {
  state = {
    inputValue: '',
    words: [],
  };

  componentDidMount() {
    this.setState({ words: this.props.words });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ words: nextProps.words });
  }

  render() {
    const { words } = this.state;
    return (
      <div className="mandatory-words">
        <SynonymListInput
          value={this.state.inputValue}
          onChange={e => this.setState({ inputValue: e.target.value })}
          onKeyUp={this._handleKeyUp}
          placeholder="Add a new word"
        />
        {words.map((word, i) => (
          <SynonymWord
            key={word + i}
            text={word}
            onDelete={e => this._handleDelete(word)}
            className="short"
          />
        ))}
        {words.length < 1 ? (
          <span className="no-words">No words have been added yet</span>
        ) : null}
      </div>
    );
  }

  _handleKeyUp = e => {
    const { inputValue } = this.state;
    const actualValue = inputValue.trim();
    if (e.keyCode === KEY_CODES.ENTER_KEY && actualValue.length > 0) {
      if (this.state.words.indexOf(actualValue) === -1) {
        const words = [actualValue].concat(this.state.words);
        this.setState({ inputValue: '', words });
        this.props.onChange(words);
        sendGoogleAnalyticsEvents(
          GOOGLE_ANALYTICS.CATEGORY.BOT_SAYS,
          GOOGLE_ANALYTICS.EVENTS.BOT_SAYS_ENTITY,
          GOOGLE_ANALYTICS.LABEL.ADD_ENTITY_FILTER_VALUE,
          GOOGLE_ANALYTICS.VALUE.SINGLE_CLICK
        );
      } else {
        createAlert('Filter already exists!', null, 'NEGETIVE');
      }
    }
  };

  _handleDelete = wordToDelete => {
    const words = this.state.words.filter(word => word !== wordToDelete);
    this.setState({ words });
    this.props.onChange(words);
    sendGoogleAnalyticsEvents(
      GOOGLE_ANALYTICS.CATEGORY.BOT_SAYS,
      GOOGLE_ANALYTICS.EVENTS.BOT_SAYS_ENTITY,
      GOOGLE_ANALYTICS.LABEL.DELETE_ENTITY_FILTER_VALUE,
      GOOGLE_ANALYTICS.VALUE.SINGLE_CLICK
    );
  };
}
